import { createAction } from '@reduxjs/toolkit';

import { UserInfo } from 'redux/types';
import { withPayloadType } from 'utils';

export const signupEmployeeStart = createAction(
  'SIGN_UP_EMPLOYEE::START',
  withPayloadType<UserInfo>(),
);
